import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { apiPaths } from '../../../../service/apiPaths';
import ApiService from '../../../../service/ApiService';

interface EmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (message: string) => void;
  onSendMail: (message: string) => void;
  selectedCount: number;
  selectedClientId?: string | null;
  leadStatus: string;
}

const EmailModal: React.FC<EmailModalProps> = ({
  isOpen,
  onClose,
  onSend,
  onSendMail,
  selectedCount,
  selectedClientId,
  leadStatus
}) => {
  const [message, setMessage] = useState("");
  const [existingComments, setExistingComments] = useState<string>("");

  useEffect(() => {
    if (selectedClientId) {
      fetchClientComments();
    }
  }, [selectedClientId]);

  const fetchClientComments = async () => {
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getAllClients}`,
      });
      const client = response.data.find(
        (client: any) => client._id === selectedClientId
      );
      if (client?.comments) {
        setExistingComments(client.comments);
        setMessage(client.comments);
      }
    } catch (error) {
      console.error("Error fetching client comments:", error);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim()) {
      toast.error("Please enter a message");
      return;
    }
    onSend(message);
    setMessage("");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <h2 className="text-xl font-semibold mb-4">
          Send Email to {selectedCount} Client(s)
        </h2>
        {existingComments && (
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Previous Comments
            </label>
            <div className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50">
              {existingComments}
            </div>
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="message"
            >
              Update Comments
            </label>
            <textarea
              id="message"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your message here..."
            />
          </div>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            >
              Update
            </button>
            {leadStatus === "approve" && (
              <button
                type="button"
                className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
                onClick={() => onSendMail(message)}
              >
                Send
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailModal;
